import { useSettings } from '@capsicum/common';
import { useAtomValue } from 'jotai';
import { useEffect, useState } from 'react';

import { isRegisteredSuccessAtom } from '../atoms';

export const useGreetingsFlowVisibility = () => {
	const [isVisible, setVisibility] = useState<boolean | null>(null);
	const isRegistrationSuccessful = useAtomValue(isRegisteredSuccessAtom);

	const {
		areSettingsLoading,
		settings: { isGreetingsScreenEnabled }
	} = useSettings();

	useEffect(() => {
		setVisibility(areSettingsLoading ? null : isGreetingsScreenEnabled && isRegistrationSuccessful);
	}, [areSettingsLoading, isGreetingsScreenEnabled, isRegistrationSuccessful]);

	return {
		isVisible,
		setVisibility
	};
};
